// 字體連結，通常使用google font
var fontList = [
  "https://fonts.googleapis.com/css2?family=Prompt:wght@400;500;600;700;900&display=swap",
  "https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400;500;600;700;900&display=swap",
];
// 一次載入所有字體連結
var allFontLink =
  "https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400;500;600;700;900&family=Prompt:wght@400;500;600;700;900&&display=swap";

export function loadAllFont() {
  if (!checkAllFontLoaded()) {
    removeCurrentFontLink();
    let fontLink = document.createElement("link");
    fontLink.href = allFontLink;
    fontLink.rel = "stylesheet";
    fontLink.type = "text/css";
    document.head.appendChild(fontLink);
  }
}

export function checkFontLoad() {
  const body_text = getBodyText();
  body_text != "" ? loadFont(body_text) : "";
}

function loadFont(text) {
  // 如果已經載入全部字型則跳過
  if (checkAllFontLoaded()) {
    return;
  }
  // 如果先前已經有載入過字型，則先移除後載入全部字型
  else if (checkIfFontLoaded()) {
    loadAllFont();
  } else {
    fontList.forEach((font) => {
      const fontLink = document.createElement("link");
      fontLink.href = font + "&text=" + encodeURIComponent(text);
      fontLink.rel = "stylesheet";
      fontLink.type = "text/css";
      fontLink.data = "font_link";
      document.head.appendChild(fontLink);
    });
  }
}

function removeCurrentFontLink() {
  const fontLinks = document.head.querySelectorAll("link");
  fontLinks.forEach((link) => {
    fontList.forEach((font) => {
      link.href.indexOf(font) != -1 ? link.remove() : "";
    });
  });
}

function checkAllFontLoaded() {
  return (
    document.head.querySelectorAll('[href="' + allFontLink + '"]').length > 0
  );
}

function checkIfFontLoaded() {
  // 依序檢查link的href值的開頭是否包含fontList的字串
  const fontLinks = document.head.querySelectorAll("link");
  let hasFontLoaded = false;
  fontList.forEach((font) => {
    let fontFound = false;
    fontLinks.forEach((link) => {
      if (link.href.indexOf(font) !== -1) {
        fontFound = true;
      }
    });
    if (fontFound) {
      hasFontLoaded = true;
    }
  });
  return hasFontLoaded;
}

function getBodyText() {
  let str = document.body.innerText;
  let uniqueChars = "";
  for (let i = 0; i < str.length; i++) {
    if (str.charAt(i) !== " " && uniqueChars.indexOf(str.charAt(i)) === -1) {
      uniqueChars += str[i];
    }
  }
  uniqueChars = uniqueChars.replace(/\s/g, "");
  str = [...new Set(uniqueChars)].join("");

  str = str.replace(
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g,
    ""
  );
  
  // 移除孤立的代理字符，避免 URIError
  str = str.replace(/[\uD800-\uDFFF]/g, '');
  return str;
}
